import React, { FC } from "react";
import { Dialog, DialogActions, FlatButton, RaisedButton, ActionsGroup } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { Content, DialogContent } from "./styled";

interface HideLayerAttributeProps {
  attributeName: string;
  onApply: VoidFunction;
  onCancel: VoidFunction;
}

export const HideLayerAttribute: FC<HideLayerAttributeProps> = ({ attributeName, onApply, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog isOpen onCloseRequest={onCancel} modal maxWidth={"35rem"} minHeight={"0"}>
      <DialogContent>
        <Content>
          <p style={{ whiteSpace: "pre" }}>
            {`${t("hideLayerAttribute.attribute", { ns: "dialogs" })} [${attributeName}] ${t(
              "hideLayerAttribute.isUsedInClassificator",
              { ns: "dialogs" },
            )}.`}
          </p>
          <p>${t("hideLayerAttribute.confirmDisableAttribute", { ns: "dialogs" })}</p>
        </Content>
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton primary onClick={onApply}>
            {t("hideLayerAttribute.disableAttribute", { ns: "dialogs" })}
          </RaisedButton>
          <FlatButton onClick={onCancel}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
